import React from "react";
import { Checkbox, CheckboxProps, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";

const hoverCheckSvg = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath d='M2 6.3 4.6 8.9 10 3.5' fill='none' stroke='%235a5a5a' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.6'/%3E%3C/svg%3E")`;

const useStyles = makeStyles({
    checkbox: {
        position: "relative",

        "&.fui-Checkbox:hover": {
            "border-color": tokens.colorNeutralStrokeAccessible,
            backgroundColor: tokens.colorSubtleBackgroundHover,
            backgroundImage: hoverCheckSvg,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "10px 10px",
        },
    },
});

interface NewformaCheckboxProps {
    checked?: CheckboxProps["checked"];
    disabled?: boolean;
    onChange?: CheckboxProps["onChange"];
    ariaLabel?: string;
    dataTestId?: string;
}

export const NewformaCheckbox: React.FC<NewformaCheckboxProps> = ({
    checked,
    disabled,
    onChange,
    ariaLabel,
    dataTestId,
}) => {
    const styles = useStyles();

    return (
        <Checkbox
            className={mergeClasses(!disabled ? styles.checkbox : undefined)}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            aria-label={ariaLabel}
            data-testid={dataTestId}
        />
    );
};
